(() => {
  const data = document.getElementById('GiestoProductTitleTranslations');
  if (!data || window.GiestoProductTitle) return;
  const terms = JSON.parse(data.textContent);
  window.GiestoProductTitle = title => {
    const source = String(title || '');
    let result = ` ${source.replaceAll('İ', 'I').replaceAll('ı', 'i').replaceAll('\u0307', '').toUpperCase()} `;
    let changed = false;
    for (const [term, translation] of terms) {
      const token = ` ${term} `;
      if (!result.includes(token) || translation.includes('Translation missing')) continue;
      result = result.replaceAll(token, ` ${translation} `);
      changed = true;
    }
    return changed ? result.trim() : source;
  };
})();
